import { useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import useFlightInfoApi from '@/src/hooks/itinerary/api/useFlightInfoApi'
import { useSearchParams } from 'next/navigation'
import useAddonsApi from '../api/useAddonsApi'
import useFareFamilyInfoApi from '../api/useFareFamilyInfoApi'
import useGetItineraryId from '../useGetItineraryId'

export const useTriggerItineraryApis = () => {
    const itineraryId = useGetItineraryId()
    const queryParams = useSearchParams()

    //View Itinerary API
    const {
        meta: itineraryMeta,
        isLoading: isItineraryLoading,
        isUninitialized: isItineraryUninitialized,
        isSuccess: isItinerarySuccess
    } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            selectFromResult: ({ data, isLoading, isUninitialized, isSuccess }) => ({
                meta: data?.meta || {},
                isLoading: isLoading,
                isUninitialized: isUninitialized,
                isSuccess: isSuccess
            })
        }
    )
    const isItineraryDataLoaded = isItinerarySuccess && !isItineraryUninitialized && !isItineraryLoading

    const skipFlightInfoApi = !isItineraryDataLoaded || itineraryMeta.fareFamilyEnabledOnReview

    const skipFareFamilyInfoApi = !isItineraryDataLoaded || !itineraryMeta.fareFamilyEnabledOnReview

    const skipAddonsApi = queryParams.get('ancillaryEnabled') === 'false'

    //Flight Info API
    useFlightInfoApi({
        skip: skipFlightInfoApi
    })

    // Fare Family Info API
    useFareFamilyInfoApi({
        skip: skipFareFamilyInfoApi
    })

    useAddonsApi({
        skip: skipAddonsApi
    })
}
